// @flow
export var valuesAreTheSame = function valuesAreTheSame(value1
/*: Array<string> */
, value2
/*: Array<string> */
)
/*: boolean */
{
  if (!value1 || !value2) {
    return false;
  }

  if (value1.length !== value2.length) {
    return false;
  }

  for (var i = 0, l = value1.length; i < l; i++) {
    if (value1[i] !== value2[i]) {
      return false;
    }
  }

  return true;
};
export var truncStringArray = function truncStringArray(arr
/*: string[] */
) {
  return (
    /*: string[] */
    arr.filter(function (el
    /*: string */
    ) {
      return !!el;
    })
  );
};
export var escapeCharacterClass = function escapeCharacterClass(separators
/*: string[] */
)
/*: string[] */
{
  var CHARACTER_CLASS_SPECIAL = ['[', ']', '^', '-', '\\'];

  var isSpecial = function isSpecial(separator
  /*: string */
  ) {
    return (
      /*: boolean */
      !!CHARACTER_CLASS_SPECIAL.find(function (spec
      /*: string */
      ) {
        return spec === separator;
      })
    );
  };

  return separators.map(function (sprtr
  /*: string */
  ) {
    return isSpecial(sprtr) ? "\\" + sprtr : sprtr;
  });
};
export var splitInput = function splitInput(str
/*: string */
, separators
/*: string[] */
)
/*: string[] */
{
  // filter out special keyboard keys (non single char) separators
  var charSeparators = separators.filter(function (sp
  /*: string */
  ) {
    return sp.length === 1;
  });
  var splitRegex = new RegExp("[" + escapeCharacterClass(charSeparators).join('') + "]");
  return truncStringArray(str.split(splitRegex));
};